import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { MarketingIP,RetentionPayment, SaveStatusObj, SOModule, SaveEventType, ActualDateChange, PlannedDateToken, ActualDateToken, ValidationItem, ValidationSummary, SpecialPoint, FileElement, SpecialPriceFile } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { SubmitConfirmDialog } from '../../../dialogs/submit-confirm-dialog/submit-confirm-dialog';
//import { dataservice } from '../../../../../z_node/models/dataservice_service';
//import { data_service } from '../../../../../z_node/data/data_service';
@Component({
  selector: 'marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.css']
})
export class MarketingComponent implements OnInit,OnChanges { 
  // soObj:SalesOrder;

  @Input() marketingObj: MarketingIP;
  @Input() soLockObtained:boolean;
  @Input() retent : RetentionPayment;
  @Output() updateSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<SpecialPoint> = new EventEmitter();
  @Output() showPriceFileManager: EventEmitter<SpecialPriceFile> = new EventEmitter();
  @Output() showSOGantt: EventEmitter<any> = new EventEmitter();

  inputDisableMessage:string = '<b>Input Disabled</b>, This form is not yet enabled';
  modifyPlanDate:boolean = false;
  disableForm:boolean = true;
  RegionArray:any[];
  disableDatasheetForm: boolean = false;
  enableDsHandover: boolean = false;

  hasPMAccess: boolean = false;
  hasEnggAccess: boolean = false;

  readonly HANDOVER_STATUS_APPROVED = 'Approved';
  readonly HANDOVER_STATUS_ON_HOLD = 'On Hold';
  readonly HANDOVER_STATUS_REJECTED_LEGACY = 'Rejected';
  readonly HANDOVER_STATUS_ON_HOLD_LEGACY = 'OnHold';
 

  Hvr:any = {};

  constructor(public _dataService:DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.ngOnChanges();
    // console.log("dataService::",this._dataService.marketingEngineers);
  }

  ngOnChanges() {
    this.disableForm = true;
    this.getRegions();
    
    if(this.soLockObtained == false){
    this.inputDisableMessage = "<b>Input Disabled</b>, You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this._dataService.hasMarketingEditAccess()) {
    this.inputDisableMessage = "<b>Input Disabled</b>, You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false
    }
    this.marketingObj.specialPriceFile.readOnly = this.disableForm
    this.marketingObj.specialPoint.readOnly = this.disableForm

    this.disableDatasheetForm = true;
    if(this.marketingObj.parentSORef.hasDatasheetInSO && this._dataService.hasDatasheetEditAccess){
      if(!this.marketingObj.parentSORef.isDatasheetAllApprovalsDone){
        this.enableDsHandover = true;
      this.disableDatasheetForm = false;
      this.inputDisableMessage = "<b>Input PARTIALLY Disabled</b>, You can Approve / On Hold Handover ONLY.";

    }
    else{
      this.enableDsHandover = false;
      this.disableDatasheetForm = true;
      this.inputDisableMessage = "<b>Input Disabled</b>, You don't have EDIT ACCESS.";
    }
  }
  else{
    this.enableDsHandover = false;
    this.disableDatasheetForm = true;
  }

  this.normalizeLegacyHandoverStatuses();
  }

  // Keep backward compatibility- existing records may still contain old rejected/onhold values.
  normalizeLegacyHandoverStatuses() {
    this.normalizeHandoverStatus(this.marketingObj.marketingHandoverDetails);
    this.normalizeHandoverStatus(this.marketingObj.pmHandoverDetails);
    this.normalizeHandoverStatus(this.marketingObj.electricalEnggHandoverDetails);
    this.normalizeHandoverStatus(this.marketingObj.mechanicalEnggHandoverDetails);
  }

  normalizeHandoverStatus(_handoverObj: any) {
    if (!_handoverObj || !_handoverObj.handoverStatus) {
      return;
    }
    if (_handoverObj.handoverStatus === this.HANDOVER_STATUS_REJECTED_LEGACY || _handoverObj.handoverStatus === this.HANDOVER_STATUS_ON_HOLD_LEGACY) {
      _handoverObj.handoverStatus = this.HANDOVER_STATUS_ON_HOLD;
    }
  }

  isOnHoldStatus(_status: string): boolean {
    return _status === this.HANDOVER_STATUS_ON_HOLD || _status === this.HANDOVER_STATUS_REJECTED_LEGACY || _status === this.HANDOVER_STATUS_ON_HOLD_LEGACY;
  }

  canShowActionButtons(_status: string): boolean {
    return !_status;
  }

  canShowApproveAfterOnHold(_status: string): boolean {
    return this.isOnHoldStatus(_status);
  }

  splPointFileManagerClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
     this.showFileManager.emit(this.marketingObj.specialPoint);
  }
  splPriceFileManagerClick(_evn:any){
    _evn.stopPropagation();

    this.showPriceFileManager.emit(this.marketingObj.specialPriceFile);
  }

  showSOGanttChart(_evnt:any){
    _evnt.stopPropagation();//stop ref

    this.showSOGantt.emit({});
  }
  addPaymentCond() {
    this.marketingObj.addPaymentCond(new RetentionPayment(null,null));
  }
  removeRetPayCond(_mark: MarketingIP, _RP : RetentionPayment){
    if(_mark && _RP){
      _mark.removePaymentCond(_RP); 
    }
  } 
  checkNumberFieldLength(elem){
    if (elem.value.length > 4) {
        elem.value = elem.value.slice(0,4); 
    }
}
  
  getRegions(){
    // this.RegionArray = [];
    // for(let i=10;i<this._dataService.regions.length;i++){
    //   var result = this._dataService.regions[i];
    //   this.RegionArray.push(result);
      this.RegionArray = this._dataService.regions;
    // }    
  }
  
  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.marketingObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.marketingObj[_actTokenKeyName].actualDate;
    this.marketingObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.marketingObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.marketingObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.marketingObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.marketingObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.marketingObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.marketingObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.marketingObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  

  saveSo(_submitToNextSection:boolean){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.Marketing, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
    }
  }
  deleteSo(_deleteSO:boolean){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Delete_Sale_Order));
    }
  }
  showSoValidation(){
    let _validList:Array<ValidationItem> = [];
    _validList.push(
      new ValidationItem("Actual Order Handing Over Date", (this.marketingObj.actualHandingOverDate ? true : false)," required to move to PM Commercial." ),
      new ValidationItem("Sale Order No", (this.marketingObj.isSalesOrderNoEntered ? true : false) ," required to move to PM Commercial." ),
      new ValidationItem("Clear PO/LOI/LOA date is required" , (this.marketingObj.clearPoReceiptDate ? true :false), " required to move to PM Commercial."  ),
      new ValidationItem("Contractual Date Firm is required" , (this.marketingObj.contractDeliveryDateFirm ? true :false), " required to move to PM Commercial."  ),
      new ValidationItem("Delivery Term is required" , (this.marketingObj.deliveryTerm ? true :false), " required to move to PM Commercial."  ),
      new ValidationItem("Cluster is required" , (this.marketingObj.regionId ? true :false), " required to move to PM Commercial."  ),
      // new ValidationItem("Customer PO No is required" , (this.marketingObj.customerPoNo ? true :false), " required to move to PM Commercial."  )
    );
    if(this.marketingObj.isSplPriceApplicable){
      _validList.push(new ValidationItem("Upload Special price file" , this.marketingObj.isSplPriceConditionFulfilled, " required to move to PM Commercial."  ))
    };
    if(this.marketingObj.contractDeliveryDateFirm !=null && !this.marketingObj.isContractDeliveryDateFirm){
      _validList.push(new ValidationItem("Weeks from Drawing Approval is required" , (this.marketingObj.contractDeliveryDateInWeek ? true :false), " required to move to PM Commercial."  ))
    };
    if(this.marketingObj.contractDeliveryDateFirm !=null && this.marketingObj.isContractDeliveryDateFirm == true){
      _validList.push(new ValidationItem("Firm Delivery Date is required" , (this.marketingObj.contractDeliveryDate ? true :false), " required to move to PM Commercial."  ))
    };
    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }


  reloadData(){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  salesOrderTitleChange(_evnt){
    this._dataService.additionalPageDetails = this.marketingObj.parentSORef.getProjDetails(); 
  }
   saveSoApproval(_submitToNextSection:boolean){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.Marketing, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_ChangeData))); // Re-using Save_ChangeData for Approval Save without pop-up for Saving SO 
    }
  }

  approveMarketingOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to Approve <strong> Datasheet Handover </strong> ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.marketingHandoverDetails.handoverDate = new Date(new Date().toDateString());
       this.marketingObj.marketingHandoverDetails.handoverStatus = "Approved";
       this.marketingObj.marketingHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.marketingHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
  rejectMarketingOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to put <strong> Datasheet Handover </strong> On Hold ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.marketingHandoverDetails.handoverDate = new Date(new Date().toDateString());
      this.marketingObj.marketingHandoverDetails.handoverStatus = this.HANDOVER_STATUS_ON_HOLD;
       this.marketingObj.marketingHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.marketingHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
  approvePmOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to Approve <strong> Datasheet Handover </strong> ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.pmHandoverDetails.handoverDate = new Date(new Date().toDateString());
       this.marketingObj.pmHandoverDetails.handoverStatus = "Approved";
       this.marketingObj.pmHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.pmHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
  rejectPmOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to put <strong> Datasheet Handover </strong> On Hold ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.pmHandoverDetails.handoverDate = new Date(new Date().toDateString());
      this.marketingObj.pmHandoverDetails.handoverStatus = this.HANDOVER_STATUS_ON_HOLD;
       this.marketingObj.pmHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.pmHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });

  }
  approveElecEnggOrder(){
 let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to Approve <strong> Datasheet Handover </strong> ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.electricalEnggHandoverDetails.handoverDate = new Date(new Date().toDateString());
       this.marketingObj.electricalEnggHandoverDetails.handoverStatus = "Approved";
       this.marketingObj.electricalEnggHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.electricalEnggHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
  rejectElecEnggOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to put <strong> Datasheet Handover </strong> On Hold ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.electricalEnggHandoverDetails.handoverDate = new Date(new Date().toDateString());
      this.marketingObj.electricalEnggHandoverDetails.handoverStatus = this.HANDOVER_STATUS_ON_HOLD;
       this.marketingObj.electricalEnggHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.electricalEnggHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }

  approveMechEnggOrder(){
 let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to Approve <strong> Datasheet Handover </strong> ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.mechanicalEnggHandoverDetails.handoverDate = new Date(new Date().toDateString());
       this.marketingObj.mechanicalEnggHandoverDetails.handoverStatus = "Approved";
       this.marketingObj.mechanicalEnggHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.mechanicalEnggHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
  rejectMechEnggOrder(){
    let dialogRef = this.dialog.open(SubmitConfirmDialog, {
         width: 40 + '%',
         data: { message: "Do you want to put <strong> Datasheet Handover </strong> On Hold ?" }
       });
   
       dialogRef.afterClosed().subscribe((confirm) => {
         if (confirm == true) {
       this.marketingObj.mechanicalEnggHandoverDetails.handoverDate = new Date(new Date().toDateString());
      this.marketingObj.mechanicalEnggHandoverDetails.handoverStatus = this.HANDOVER_STATUS_ON_HOLD;
       this.marketingObj.mechanicalEnggHandoverDetails.handoverById = this._dataService.userId;
       this.marketingObj.mechanicalEnggHandoverDetails.handoverByName = this._dataService.userName;
   
       this.saveSoApproval(false);
         }
       });
  }
}
